





















































import Vue from 'vue';

import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';

import Axios from 'axios';
import JwtDecode from 'jwt-decode';

interface Data {
  email: string;
  pass: string;
  passField: any;
  passConf: string;
  passConfField: any;
  token: string;

  passEqual: boolean;
}

export default Vue.extend({
  data(): Data {
    return {
      email: '',
      pass: '',
      passField: null,
      passConf: '',
      passConfField: null,
      token: '',

      passEqual: true,
    };
  },
  mounted() {
    this.token = this.$route.params.token;

    const tokenObj: any = JwtDecode(this.token);
    this.email = tokenObj.sub;

    const fields: any = document.querySelectorAll('.mdc-text-field');
    for (const fieldElem of fields) {
      if (fieldElem.dataset.name === 'pass') {
        this.passField = new MDCTextField(fieldElem);
      } else if (fieldElem.dataset.name === 'passConf') {
        this.passConfField = new MDCTextField(fieldElem);
      }
    }

    const buttonElem: any = document.querySelector('.mdc-button');
    const buttonRipple = new MDCRipple(buttonElem);
  },
  updated() {
    if (this.pass !== this.passConf) {
      this.passEqual = false;
    } else {
      this.passEqual = true;
    }
    this.passField.valid = this.passEqual;
    this.passConfField.valid = this.passEqual;
  },
  methods: {
    submit() {
      const vue = this;
      Axios.post('/API/register', { Email: this.email, Pass: this.pass, Token: this.token })
        .then(() => vue.$router.push('/login'))
        .catch((err) => console.warn(err));
    },
  },
});
